module.exports = __webpack_public_path__ + "static/img/mobile-car1.5a73def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/mobile-car1.png
// module id = WtYp
// module chunks = 17